import {Component, Input, OnDestroy, OnInit, QueryList, ViewChildren} from '@angular/core';
import {MachineGroup} from '@models/adminstration/machine-group/machine-group';
import {SortEvent, TableHeaderSortableDirective} from '@shared/table-header-sortable/table-header-sortable.directive';
import {TableHeaderSortableService} from '@services/table-header-sortable/table-header-sortable.service';
import {TranslateService} from '@ngx-translate/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {ElasticSearchResponseEntity} from '@models/elastic-search/response/elastic-search-response-entity';
import {ElasticSearchResult} from '@models/elastic-search/response/elastic-search-result';
import {MachineryGroupDetailsService} from '@services/administration/machine-group/machinery-group-details.service';

@Component({
    selector: 'scitis-admin-machine-group-groups',
    templateUrl: './machine-group-groups.component.html',
    styleUrls: ['./machine-group-groups.component.scss'],
    standalone: false
})
export class MachineGroupGroupsComponent implements OnInit, OnDestroy {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  @Input()
  machineGroupName: string = '';
  @Input()
  machineGroupId: number | null = null;
  @Input()
  whiteListedMachineryGroups: number[] | null = null;


  groups: MachineGroup[] = new Array<MachineGroup>();

  @ViewChildren(TableHeaderSortableDirective) sortableHeaders: QueryList<TableHeaderSortableDirective> = new QueryList<TableHeaderSortableDirective>();

  constructor(private tableHeaderSortableService: TableHeaderSortableService,
              public translate: TranslateService,
              private machineryGroupDetails: MachineryGroupDetailsService) {
  }


  onColumnSort({column, direction}: SortEvent) {
    this.sortableHeaders = this.tableHeaderSortableService.resetHeaders(this.sortableHeaders, column);
    this.groups = this.tableHeaderSortableService.sortItems<MachineGroup>(this.groups, column, direction);
  }

  ngOnInit(): void {
    this.setGroups();
  }

  ngOnDestroy(): void {

    this.destroy$.next(true);
    this.destroy$.complete();
  }

  private setGroups() {
    this.machineryGroupDetails.listChildMachineryGroups(this.machineGroupId, this.whiteListedMachineryGroups)
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (success: ElasticSearchResponseEntity) => {
        if (success?.result?.data && success.result.data.length > 0) {
          const result: ElasticSearchResult = success.result;
          this.groups = result.data;
        }
      }, error: (error) => {
        console.log(error);
      }
    });
  }
}
